import React, { useState, useEffect, useContext } from "react";
import { useQuery } from 'react-query';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { getApplicationById, dopApprovals, getRegionPresident } from "../../../api/apiServices";
import AuthContext from "../../../context/AuthProvider";
import 'react-confirm-alert/src/react-confirm-alert.css';
import toast, { Toaster } from 'react-hot-toast'


const DopForm = () => {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    const { auth } = useContext(AuthContext)
    const params = useParams();
    const id = parseInt(params.id)

    // const [application, setApplication] = useState([]);
    // const [region_president, setRegionPresident] = useState("");
    const [dop_approval_rejection_reason, setReason] = useState("");

    const {
        data: dopApproval,
    } = useQuery(['dopApproval', id], () => getApplicationById(id));

    const {
        data: region_president
    } = useQuery(
        dopApproval?.region_code?.length ? ["region_president", dopApproval?.region_code] : null,
        () => getRegionPresident(dopApproval?.region_code),
    )


    let dop_approved_status = false
    let application_id = dopApproval?.id;
    let dateJoined = new Date(dopApproval?.date_joined)
    let applicationYear = String(dateJoined.getFullYear());

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/declined_applications";

    const handleOverride = (e) => {
        e.preventDefault();

        if (!dop_approval_rejection_reason) {
            toast.error("Please provide reason for overriding the application", {
                duration: 5000
            })
            return false
        }

        const data = {
            application_id: application_id,
            year: applicationYear,
            dop_approved_status: true,
            dop_approval_rejection_reason: dop_approval_rejection_reason,
        }
        dopApprovals(data).then((res) => {
            toast.success("Member successfully approved", {
                duration: 5000
            });
            navigate(from, { replace: true });
        })
    }
    const handleAgree = (e) => {
        e.preventDefault();

        if (!dop_approval_rejection_reason) {
            toast.error("Please provide reason for agreeing with the Region", {
               duration: 5000
            })
            return false
        }

        const data = {
            application_id: application_id,
            year: applicationYear,
            dop_approved_status: false,
            dop_approval_rejection_reason: dop_approval_rejection_reason,
        }
        dopApprovals(data).then((res) => {
            toast.success("Member application declined ", {
                duration: 5000
            });
            navigate(from, { replace: true });
        })
    }
    const handleCancel = (e) => {
        e.preventDefault();
        navigate(from, { replace: true });
    }

    const content = (
        <div className="panel panel-success panel-br-4">
            <div className="panel-heading">
                <div className="row">
                    <div className="col-sm-9">
                        <h4 className="panel-title">
                            <i className="fa fa-file-text" aria-hidden="true"></i>
                            <span> Application Details</span>
                        </h4>
                    </div>
                </div>
            </div>
            <div className="panel-body">

                <div className="table-responsive lg">
                    <table className="table table-borderless">
                        <tbody>
                            <><tr>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>NDC Number</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{dopApproval?.ndc_membership_number}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>VoterID Number</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{dopApproval?.voter_id_number}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Application Date</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "no-wrap" }}> :	{dopApproval?.date_joined}</td>
                            </tr><tr>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>LastName</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{dopApproval?.last_name}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>FirstName</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{dopApproval?.first_name}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>MiddleName</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{dopApproval?.middle_name}</td>
                                </tr><tr>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Email</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{dopApproval?.email}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Phone Number</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{dopApproval?.mobile_number}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Gender</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{dopApproval?.gender}</td>
                                </tr>
                                <tr>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Region</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{dopApproval?.region}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Constituency</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{dopApproval?.constituency}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Branch</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{dopApproval?.branch}</td>
                                </tr>
                                <tr>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Recommended By</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{dopApproval?.recommended_by}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colSpan={6}>
                                        <strong style={{ fontSize: "18px", fontWeight: "700", color: "brown" }}>Regional President Information</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Name</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{region_president?.fullname}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Phone Number</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{region_president?.mobile_number}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Email</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{region_president?.email}</td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>
                                        <strong style={{ fontSize: "18px", fontWeight: "700", color: "brown" }}>Regional Approval Information</strong>
                                    </td>
                                    <td colSpan={3}>
                                        <strong style={{ fontSize: "18px", fontWeight: "700", color: "brown" }}><a rel="noreferrer" target="_blank" href="https://www.ndcpayment.com/dues/pay">Click to verify applicant NDC membership</a></strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3} style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Reason for Approval/Decline</td>
                                    <td colSpan={3} style={{ fontSize: "16px", fontWeight: "700", color: "brown", textAlign: "left", whiteSpace: "pre-wrap" }}> 	{dopApproval?.regional_approval_rejection_reason}</td>
                                </tr>
                            </>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )

    const approvalForm = (
        <div className="panel panel-success panel-br-4">
            <div className="panel-heading">
                <div className="row">
                    <div className="col-sm-9">
                        <h4 className="panel-title">
                            <i className="fa fa-file-text" aria-hidden="true"></i>
                            <span> Application Approval/Decline</span>
                        </h4>
                    </div>
                </div>
            </div>
            <div className="panel-body">
                <form onSubmit={handleOverride}>
                    <div className="form-group row">
                        <label htmlFor="reason" className="col-sm-3">Approval/Decline Reason</label>
                        <div className="col-sm-6">
                            <textarea
                                rows="4"
                                type="textarea"
                                id="reason"
                                placeholder="Type reason for approval or decline"
                                autoComplete="off"
                                onChange={(e) => setReason(e.target.value)}
                                value={dop_approval_rejection_reason}
                                required
                                name="reason"
                                className="form-control"
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="" className="col-sm-3 col-form-label"></label>
                        <div className="col-sm-1">
                            <button type="submit" className="btn btn-danger" onClick={handleAgree}>
                                Agree
                            </button>
                        </div>
                        <div className="col-sm-1">
                            <button type="submit" className="btn btn-success">
                                Override
                            </button>
                        </div>
                        <div className="col-sm-2">
                            <button type="submit" className="btn btn-warning" onClick={handleCancel}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )



    return (
                <><section className="content-header">
            <Toaster toastOptions={{ position: "top-center" }} />
            <h1>DOP - Application Review/Approval</h1>
        </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            <span> Application Review/Approval </span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {content}
                            </div>
                            <div className="panel-footer">
                                {approvalForm}
                            </div>
                        </div>
                    </div>
                    <div className="box-body"></div>
                </div>
            </section></>
    );
}

export default DopForm;